import AccordionDetails from '@mui/material/AccordionDetails';
export default AccordionDetails;
export * from '@mui/material/AccordionDetails';
